<template>
  <div id="app">
    <div class="row" style="padding-top: 2rem">
      <div class="col-4">
        <img src="../static/img/logo.png" style="float: right;max-width: 100%;"/>
      </div>
      <div class="col-3"></div>
      <div class="col-2" style="padding-right: 1rem;">
         <router-link to="/">
          <span class="header_btn" :style="{float: 'right',fontSize : 1.5*windowWidth/100+'px'}">首页</span>
        </router-link>
      </div>
      <div class="col-2" style="padding-left: 0.5rem;">
        <router-link to="/deposit">
          <span class="header_btn" :style="{float: 'left',fontSize : 1.5*windowWidth/100+'px'}">充值</span>
        </router-link>
      </div>
      <div class="col-3"></div>
    </div>
    <router-view/>
    <footer style="padding-top: 8rem;">
      <p :style="{textAlign: 'center',fontSize : 1*windowWidth/100+'px'}">邮箱：xiaolin@bgpl.wecom.work 湖北音梦网络科技有限公司 <a href="https://beian.miit.gov.cn/">鄂ICP备19021445号</a></p>
  </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      windowWidth: 1920
    }
  },
  mounted () {
    this.windowWidth = document.body.clientWidth
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: url(../static/img/younibj.png);
  height: 100%;
  width: 100%;
  position:fixed;
  background-size:100% 100%;
}

.header_btn {
  font-weight: 500;
  cursor: pointer;
  margin-top: 1rem;
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue